

























































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { ReasonForPermissionService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { ReasonForPermissionModel } from '@/models/config'

@Component({
    name: 'TableListReasonForPermissions',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListReasonForPermissions extends Vue {
    loading = false
    items: [ReasonForPermissionModel] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'description',
            sortable: true,
            label: 'Descripción'
        },
        {
            key: 'type',
            sortable: true,
            label: 'Tipo'
        },
        {
            key: 'abbreviated',
            sortable: true,
            label: 'Abreviatura'
        },
        {
            key: 'has_subsidy',
            sortable: true,
            label: 'Subsidio',
            formatter: (value: boolean) => {
                return value ? 'SI' : 'NO'
            }
        },
        {
            key: 'apply_sunday_discount',
            sortable: true,
            label: 'Aplica Dscto. Dominical',
            formatter: (value: boolean) => {
                return value ? 'SI' : 'NO'
            }
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getreasonsWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getreasonsWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getreasonsWithPagination()
    }

    async getreasonsWithPagination () {
        this.loading = true
        const response = await ReasonForPermissionService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
